import {
  RawApiClient,
  throwNon200ResponseTransformer,
  parseBodyAsJsonResponseTransformer,
} from '@plangrid-private/web-api-clients';
import getEnvironmentRequestTransformer from '@plangrid-private/web-api-clients/dist/rawClients/getEnvironmentRequestTransformer';

import {
  ENV_CONFIG_KEYS,
  fetchWithToken,
  getEnvValue,
} from '@adsk/acs-sc-web-platform-api';

import buildSearchParams from './buildSearchParams';
import { APSV2Form, CacaForm, CreateFormV2RequestBody } from '../types';
import createFormTransformer from './transformers/createForm';
import { GetFoldersV1Response } from './transformers/getFolders';
import getFormsTransformer from './transformers/getForms';

export const formsRoutes = {
  allInProjectForType: (projectId: string, formTemplateId: string) =>
    `/v8/project/${projectId}/field-report-types/${formTemplateId}/reports`,
  folders: (projectId: string, folderId?: string) =>
    folderId
      ? `${getEnvValue(
          ENV_CONFIG_KEYS.FORMS_API_URL,
        )}/development/v1/projects/${projectId}/folders/${folderId}`
      : `${getEnvValue(
          ENV_CONFIG_KEYS.FORMS_API_URL,
        )}/development/v1/projects/${projectId}/folders`,
};

const formsRoutesScalingFormsM7 = {
  createForm: (projectId: string, formTemplateId: string) =>
    `${getEnvValue(
      ENV_CONFIG_KEYS.FORMS_API_URL,
    )}/development/v2/projects/${projectId}/form-templates/${formTemplateId}/forms`,
  allInProjectForType: (projectId: string) =>
    `${getEnvValue(
      ENV_CONFIG_KEYS.FORMS_API_URL,
    )}/development/v2/projects/${projectId}/forms`,
};

export const rawFormsClient = new RawApiClient<unknown>({
  requestTransformers: [getEnvironmentRequestTransformer('forms')],
  responseTransformers: [
    throwNon200ResponseTransformer,
    parseBodyAsJsonResponseTransformer,
  ],
});

export const formsClient = {
  createForm: (
    projectId: string,
    formTemplateId: string,
    body: CreateFormV2RequestBody,
  ) =>
    fetchWithToken(
      `${formsRoutesScalingFormsM7.createForm(projectId, formTemplateId)}`,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(createFormTransformer.translateBody(body)),
      },
    ) as Promise<APSV2Form>,
  getForms: (
    projectId: string,
    formTemplateId: string,
    params?: Record<string, string | number>,
  ) =>
    rawFormsClient.get({
      url: formsRoutes.allInProjectForType(projectId, formTemplateId),
      params,
    }) as Promise<{ items: CacaForm[]; total: number }>,
  getFormsScalingFormsM7: (
    projectId: string,
    formTemplateId: string,
    params: Record<string, string | number> = {},
  ) => {
    return fetchWithToken(
      `${formsRoutesScalingFormsM7.allInProjectForType(
        projectId,
      )}?${buildSearchParams(
        getFormsTransformer.translateQueryParams(params),
      )}`,
    );
  },
  getFolders: async (
    projectId: string,
    params: { offset: number; limit: number },
  ) =>
    fetchWithToken<GetFoldersV1Response>(
      `${formsRoutes.folders(projectId)}?${buildSearchParams(params)}`,
    ),
};
